import {useMemo} from 'react'

export const useNextConfig = () => useMemo(() => {
  const nextEl = document.getElementById('__NEXT_DATA__')
    return {
      assetPrefix: '',
      ...((nextEl && nextEl.innerHTML) ? JSON.parse(nextEl.innerHTML) : {})
    }
}, [])